import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import { ProgramaService } from "../../services/ProgramaService";
import { ExercicioService } from "../../services/ExercicioService";

export default {
    name: "GerenciarProgramas",
    components: {
        Breadcrumb,
        ActionButtons,
        StandardPagination
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Programas',
                disabled: true
            }
        ],
        // Controle de responsividade
        isMobile: false,
        isTablet: false,
        windowWidth: 0,
        // Headers base da tabela
        baseHeaders: [
            { text: '', align: 'center', value: 'data-table-select', sortable: false, width: '50px', priority: 1 },
            { text: 'Exercício', align: 'center', value: 'exercicio.ano', width: '100px', priority: 2 },
            { text: 'Código Programa', align: 'center', value: 'codigo_programa', width: '150px', priority: 1 },
            { text: 'Descrição Programa', align: 'center', value: 'descricao', width: '300px', priority: 1 },
            { text: 'Status', align: 'center', value: 'ativo', width: '100px', priority: 2 },
        ],
        filters: {
            exercicioFilter: '',
            codigoProgramaFilter: '',
            descricaoProgramaFilter: '',
            statusFilter: ''
        },
        statusOptions: [
            { text: 'Todos', value: null },
            { text: 'Ativo', value: true },
            { text: 'Inativo', value: false }
        ],
        items: [],
        selectedItems: [],
        exerciciosOptions: [],
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        showFilters: true,
        loading: false
    }),
    computed: {
        isAllSelected() {
            return this.selectedItems.length === this.items.length && this.items.length > 0;
        },
        isIndeterminate() {
            return this.selectedItems.length > 0 && this.selectedItems.length < this.items.length;
        },
        // Headers computados - sempre mostra todas as colunas
        computedHeaders() {
            // Sempre retorna todas as colunas, independente da resolução
            // O scroll horizontal cuidará da navegação em telas pequenas
            return this.baseHeaders;
        }
    },
    created() {
        this.listarProgramasPaginado();
        this.listarExerciciosSelect();
        this.handleResize();
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
        'filters.exercicioFilter': function() {
            this.page = 1;
            this.listarProgramasPaginado();
        },
        'filters.codigoProgramaFilter': function() {
            this.page = 1;
            this.listarProgramasPaginado();
        },
        'filters.descricaoProgramaFilter': function() {
            this.page = 1;
            this.listarProgramasPaginado();
        },
        'filters.statusFilter': function() {
            this.page = 1;
            this.listarProgramasPaginado();
        }
    },
    methods: {
        async listarProgramasPaginado() {
            try {
                this.loading = true;
                const filter = this.prepareFormFilter();

                const response = await ProgramaService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.selectedItems = [];
                } else {
                    console.error('Não foi possível obter os programas.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os programas:', error);
            } finally {
                this.loading = false;
            }
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                    this.exerciciosOptions?.unshift({
                        text: "Selecione",
                        value: "",
                    });

                } else {
                    console.error('Não foi possível obter os programas.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os programas:', error);
            }
        },
        async destroyProgramas() {
            try {
                const ids = this.selectedItems.map(programa => programa.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("programas[]", id);
                });

                const response = await ProgramaService.destroy(formData);

                if (!response) {
                    console.error('Não foi possível excluir os programas.');
                }

                this.listarProgramasPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao excluir os programas:', error);
            }
        },
        async activateProgramas() {
            try {
                const ids = this.selectedItems.map(programa => programa.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("programas[]", id);
                });

                const response = await ProgramaService.activate(formData);

                if (!response) {
                    console.error('Não foi possível ativar os programas.');
                }

                this.listarProgramasPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao ativar os programas:', error);
            }
        },
        async deactivateProgramas() {
            try {
                const ids = this.selectedItems.map(programa => programa.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("programas[]", id);
                });

                const response = await ProgramaService.deactivate(formData);

                if (!response) {
                    console.error('Não foi possível desativar os programas.');
                }

                this.listarProgramasPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao desativar os programas:', error);
            }
        },

        prepareFormFilter() {
            const filter = new FormData();

            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);

            if (this.filters.exercicioFilter) {
                filter.append("exercicio", this.filters.exercicioFilter);
            }

            if (this.filters.codigoProgramaFilter) {
                filter.append("codigo", this.filters.codigoProgramaFilter);
            }

            if (this.filters.descricaoProgramaFilter) {
                filter.append("descricao", this.filters.descricaoProgramaFilter);
            }

            if (this.filters.statusFilter !== null) {
                filter.append("ativo", this.filters.statusFilter);
            }

            return filter;
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.selectedItems = [];
            } else {
                this.selectedItems = [...this.items];
            }
        },
        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        truncateText(text, maxLength) {
            if (!text) return '';
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
        },
        getRowClass(index) {
            return index % 2 === 0 ? 'even-row' : 'odd-row';
        },
        navigateToCreate() {
            this.$router.push('/programas/criar');
        },
        navigateToEdit() {
            if (this.selectedItems.length === 1) {
                this.$router.push(`/programa/editar/${this.selectedItems[0].id}`);
            }
        },
        handleExport() {
            this.$globalAlert('Funcionalidade de exportação será implementada em breve!', 'info');
        },
        handlePageChanged(newPage) {
            this.page = newPage;
            this.listarProgramasPaginado();
        },
        handleItemsPerPageChanged(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarProgramasPaginado();
        },
        // Método para detectar mudanças no tamanho da tela
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.isMobile = this.windowWidth < 768;
            this.isTablet = this.windowWidth >= 768 && this.windowWidth < 1024;
        }
    }
};
